/**
 * Tiny class-name joiner. Filters falsy values so conditional classes stay
 * terse without pulling in clsx/tailwind-merge for this foundational phase.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
